import { defaultReducer } from 'app/store/defaultReducer';
import { createReducerTool, createStateTool } from 'app/store/withDevTools';
import { ContasPagarTypes } from './contasPagarAction';

export const ContasPagarInitState = createStateTool({
  registro: undefined,
  visualizar: false,
  cadastrar: false,
  baixarConta: false,
  page: { content: [] },
  requestParams: {
    page: 0,
    size: 15,
    q: undefined,
    sort: 'dataVencimento,desc',
    totalCount: undefined,
  },
  selection: [],
  message: undefined,
  search: undefined,
  selecionados: [],
  carregandoRegistro: false,
  carregandoRegistros: false,
  emitirRecibo: false,
  emitirDetalhes: false,
  tipoSelecao: 'NENHUM', // NENHUM, TODOS_PAGINA, TODOS_FILTRO
  somatorios: {},
  initialAbaSelecionada: 0,
  filtroAvancado: {
    mesCompetencia: undefined,
    situacao: undefined,
    fornecedor: undefined,
    categoria: undefined,
    dataVencimento: undefined,
    dataVencimentoInicio: undefined,
    dataVencimentoFim: undefined,
    dataPagamento: undefined,
    dataPagamentoInicio: undefined,
    dataPagamentoFim: undefined,
    dataEmissao: undefined,
    valor: undefined,
    documentoFiscal: undefined,
    conta: undefined,
    formaPagamento: undefined,
    origemLancamento: undefined,
    despesasRegulares: false,
    tipoConsultaConciliacao: 'TODOS',
  },
  filtroAvancadoFormatado: {
    categoriaId: undefined,
    contaId: undefined,
    dataEmissao: undefined,
    dataVencimento: undefined,
    dataVencimentoInicio: undefined,
    dataVencimentoFim: undefined,
    dataPagamento: undefined,
    dataPagamentoInicio: undefined,
    dataPagamentoFim: undefined,
    despesasRegulares: false,
    documentoFiscal: undefined,
    formaPagamento: undefined,
    fornecedorId: undefined,
    mesCompetencia: undefined,
    origemLancamento: undefined,
    situacao: undefined,
    valor: undefined,
    tipoConsultaConciliacao: 'TODOS',
  },
  abrirImportModal: false,
  arquivo: '',
});

function reducer(state, action, types) {
  if (action.type === ContasPagarTypes.SET_FILTRO_AVANCADO) {
    return {
      ...state,
      filtroAvancado: action.payload,
    };
  }

  if (action.type === ContasPagarTypes.SET_FILTRO_AVANCADO_FORMATADO) {
    return {
      ...state,
      filtroAvancadoFormatado: action.payload,
    };
  }

  if (action.type === ContasPagarTypes.FECHAR_MODAL) {
    return {
      ...state,
      cadastrar: false,
      visualizar: false,
      baixarConta: false,
      initialAbaSelecionada: 0,
      buscaAvancada: false,
    };
  }
  if (action.type === ContasPagarTypes.BAIXA_CONTA_PAGAR) {
    return {
      ...state,
      cadastrar: false,
      visualizar: false,
      baixarConta: true,
      registro: action.payload,
    };
  }
  if (action.type === ContasPagarTypes.BUSCAR_SOMATORIOS) {
    return {
      ...state,
      somatorios: action.payload,
    };
  }
  if (action.type === types.SUCESSO) {
    state.baixarConta = false;
  }
  if (action.type === types.SELECIONAR_ABA_CADASTRO) {
    return {
      ...state,
      initialAbaSelecionada: action.payload,
    };
  }
  if (action.type === types.BUSCAR) {
    return {
      ...state,
      visualizar: false,
      cadastrar: false,
      page: action.payload,
    };
  }
  if (action.type === ContasPagarTypes.SET_ARQUIVO_IMPORT) {
    return {
      ...state,
      arquivo: action.payload,
    };
  }
  return defaultReducer(state, action, types);
}

export const ContasPagarReducer = createReducerTool(reducer, ContasPagarTypes);
